import React from 'react';
import PropTypes from 'prop-types';

// Import utilites
import { renderFields } from 'components/utilities/form/renderFields';

// Import translation
import { useTranslation } from 'react-i18next';

// Import fields
import { FILTER_FIELDS } from 'components/helpers/filters_helpers/filter_fields';

const Fields = ({ submitting, tableType, filtersSuggestions }) => {
	const { t } = useTranslation();

	return (
		<React.Fragment>
			<h3>{t('filters:drawer_title')}</h3>
			<div className="hr-line-solid">&nbsp;</div>
			{FILTER_FIELDS[tableType]
				? FILTER_FIELDS[tableType].map((item, index) =>
						renderFields({
							item,
							index,
							submitting,
							selectResources: filtersSuggestions
						})
				  )
				: t('filters:filters_unavailable')}
		</React.Fragment>
	);
};

Fields.propTypes = {
	submitting: PropTypes.bool.isRequired,
	tableType: PropTypes.string.isRequired
};

export default Fields;
